// extracted by mini-css-extract-plugin
export default {"mainContainer":"institutions_admin_mainContainer__snyFg","unit":"institutions_admin_unit__ZnJPX"};